var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',[_c('b-checkbox',{attrs:{"disabled":_vm.disabled},on:{"input":_vm.handleInput},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }